if (!customElements.get('footer-expert-text')) {
  customElements.define(
    'footer-expert-text',
    class FooterExpertText extends HTMLElement {
      constructor() {
        super();

        this.showText = this.dataset.showText || 'Ver más';
        this.hideText = this.dataset.hideText || 'Ver menos';
        this.lineLimit = parseInt(this.dataset.lineLimit, 10) || 4;
        this.isExpanded = false;
      }

      connectedCallback() {
        this.contentEl = this.querySelector('.footer-expert-text__content');
        this.footerEl = this.querySelector('.footer-expert-text__footer');
        this.toggleEl = this.querySelector('.footer-expert-text__toggle');
        this.toggleTextEl = this.toggleEl?.querySelector('.btn__text');

        if (!this.contentEl || !this.toggleEl || !this.footerEl) {
          return;
        }

        this.contentEl.style.overflow = 'hidden';
        this.contentEl.style.transition = 'max-height 0.4s ease';

        window.requestAnimationFrame(() => this.setup());

        this.toggleEl.addEventListener('click', this.onToggle.bind(this));
        window.addEventListener('resize', this.onResize.bind(this));
      }

      getCollapsedHeight() {
        const lineHeight = parseFloat(getComputedStyle(this.contentEl).lineHeight) || 22;
        return lineHeight * this.lineLimit;
      }

      setup() {
        this.collapsedHeight = this.getCollapsedHeight();
        const fullHeight = this.contentEl.scrollHeight;

        if (fullHeight <= this.collapsedHeight + 1) {
          this.footerEl.hidden = true;
          this.contentEl.style.maxHeight = 'none';
          return;
        }

        this.footerEl.hidden = false;
        this.contentEl.style.maxHeight = `${this.collapsedHeight}px`;
        this.toggleEl.setAttribute('aria-expanded', 'false');
      }

      onResize() {
        if (this.footerEl.hidden) {
          return;
        }
        this.collapsedHeight = this.getCollapsedHeight();
        if (this.isExpanded) {
          this.contentEl.style.maxHeight = `${this.contentEl.scrollHeight}px`;
        } else {
          this.contentEl.style.maxHeight = `${this.collapsedHeight}px`;
        }
      }

      expand() {
        this.isExpanded = true;
        this.classList.add('is-expanded');
        this.toggleEl.setAttribute('aria-expanded', 'true');
        if (this.toggleTextEl) {
          this.toggleTextEl.textContent = this.hideText;
        }

        this.contentEl.style.maxHeight = `${this.contentEl.scrollHeight}px`;

        this.contentEl.addEventListener(
          'transitionend',
          () => {
            if (this.isExpanded) {
              this.contentEl.style.maxHeight = 'none';
            }
          },
          { once: true }
        );
      }

      collapse() {
        this.isExpanded = false;
        this.classList.remove('is-expanded');
        this.toggleEl.setAttribute('aria-expanded', 'false');
        if (this.toggleTextEl) {
          this.toggleTextEl.textContent = this.showText;
        }

        this.contentEl.style.maxHeight = `${this.contentEl.scrollHeight}px`;
        void this.contentEl.offsetHeight;
        window.requestAnimationFrame(() => {
          this.contentEl.style.maxHeight = `${this.collapsedHeight}px`;
        });
      }

      onToggle(event) {
        event.preventDefault();
        if (this.isExpanded) {
          this.collapse();
        } else {
          this.expand();
        }
      }
    }
  );
}
